var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "content" } }, [
    _c("div", { staticClass: "header col-md-12" }, [
      _c("div", { staticClass: "header-inner row align-items-center" }, [
        _c("div", { staticClass: "col-md-4 left" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("sidebar.pos")) +
                " > " +
                _vm._s(_vm.$t("sidebar.poscashier")) +
                "\n        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8 right" }, [
          _c(
            "div",
            { staticClass: "action" },
            [
              _c("base-dropdown-filter-download", {
                attrs: { items: _vm.DOWNLOAD_EXTS, loading: false },
                on: { onSelect: _vm.handleSelectDownload }
              }),
              _vm._v(" "),
              _c("base-filter-data-type", {
                attrs: { type: _vm.dataType, items: _vm.REPORT_DATA_TYPES },
                on: { onSelect: _vm.handleSelectDataType }
              }),
              _vm._v(" "),
              _c("base-dropdown-filter-date-range", {
                attrs: {
                  type: _vm.dateType,
                  range: { start: _vm.dateStart, end: _vm.dateEnd }
                },
                on: { onSubmit: _vm.handleSubmitFilter }
              })
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content col-md-12" }, [
      !_vm.ready
        ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
        : _c(
            "div",
            { staticClass: "col-md-12 no-padding mt-2" },
            [
              _vm.posCashiers.length
                ? [
                    _c("section", { staticClass: "mt-2 mb-4" }, [
                      _c(
                        "div",
                        [
                          _c("section-title", {
                            attrs: {
                              title: _vm.datePeriod(_vm.dateStart, _vm.dateEnd),
                              fontweight: "bold"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "keep-alive",
                      [
                        _vm.dataType === _vm.REPORT_DATA_TYPE_VALUE.TABLE
                          ? _c("report-cashier-table", {
                              attrs: { items: _vm.posCashiers }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.dataType === _vm.REPORT_DATA_TYPE_VALUE.CHART_BAR
                          ? _c("report-cashier-chart", {
                              attrs: {
                                items: _vm.posCashiers,
                                selectedLabels: _vm.chartSelectedLabels,
                                type: "bar"
                              },
                              on: {
                                "update:selectedLabels": function($event) {
                                  _vm.chartSelectedLabels = $event
                                },
                                "update:selected-labels": function($event) {
                                  _vm.chartSelectedLabels = $event
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.dataType === _vm.REPORT_DATA_TYPE_VALUE.CHART_LINE
                          ? _c("report-cashier-chart", {
                              attrs: {
                                items: _vm.posCashiers,
                                selectedLabels: _vm.chartSelectedLabels,
                                type: "line"
                              },
                              on: {
                                "update:selectedLabels": function($event) {
                                  _vm.chartSelectedLabels = $event
                                },
                                "update:selected-labels": function($event) {
                                  _vm.chartSelectedLabels = $event
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                : [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("message.nodatafound")) +
                        "\n      "
                    )
                  ]
            ],
            2
          )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c2cf52c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c2cf52c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/report/pos/Cashier.vue
// module id = null
// module chunks = 